import React, { useEffect } from "react";
import "./members.css";
import Member from "../../components/member/member";
import MemberCSV from "../../components/memberCSV/memberCSV";
import MemberTestSheet from "../../components/memberCSV/memberTestSheet";
import Search from "../../components/search/search";
import TeamFilter from "../UI/TeamFilter/teamFilter";
import { withRouter, Link } from "react-router-dom";
import * as Moment from "moment";
import Menu from "../menu/menu";

import * as _ from "lodash";

import styled, { css } from "styled-components";
import MemberTestResultSheet from "../memberCSV/memberTestResultSheet";
import MembersDetailTable from "../memberCSV/membersDetailTable";
import MembersKeikenTable from "../memberCSV/membersKeikenTable";

import {
  SwipeableList,
  SwipeableListItem
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";

// Load Icons
import { ReactComponent as _NewIcon } from "../../assets/plus-sign.svg";
import { ReactComponent as _KickIcon } from "../../assets/kick.svg";

const NewIcon = styled(_NewIcon)`
  width: 20px;
  height: 20px;

  color: #fff;
  fill: currentColor;
  transition: all 200ms;

  div &:hover {
    transform: scale(1.3);
  }
`;



// Icons
const KickIcon = styled(_KickIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;

  color: #ff0;
  fill: currentColor;
  transition: all 200ms;
`;

Moment.updateLocale("en", {
  relativeTime: {
    future: "om %s",
    past: "%s siden",
    s: "få sekunder",
    ss: "%d sekunder",
    m: "ét minut",
    mm: "%d minutter",
    h: "en time",
    hh: "%d timer",
    d: "en dag",
    dd: "%d dage",
    M: "et måned",
    MM: "%d måneder",
    y: "et år",
    yy: "%d år"
  },
  months: [
    "Januar",
    "Februar",
    "Marts",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "December"
  ],
  monthsShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec"
  ]
});

const HeaderWrapper = styled.div`
  /* .members-page .members-header-wrapper  */
  ${props =>
    props.status == "ny"
      ? css`
          background: #060;
        `
      : css`
          background: #00224d;
        `}

  box-shadow: inset 0px 0px 30px 0px #00224d;

  /* flex: 0 0 35px; */
  padding: 6px 0 5px 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  /* min-height: 50px; */
  /* height: 100%; */
  flex: 0 0 140px;

  .members-header-top {
    display: flex;
    flex-direction: row;
    padding: 2px 0 8px 0;
    justify-content: center;
    align-items: center;
    flex: 1 1 auto;
  }
  .members-header-top img {
    /* flex: 0 0 20px; */
    height: 40px;
  }

  /* Search and Team filter goes here */
  .header-bottom {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }

  h3 {
    color: white;
    margin: 0;
    /* flex: 0 1 auto; */
    font-size: 0.8em;
    padding-left: 10px;
  }
`;

/***********************************
 *
 * MEMBERS COMPONENT
 *
 **********************************/
const Members = props => {
  useEffect(() => {
    props.updateFilteredMembers(props.searchValue, props.teamId, props.status);
  }, []);

  useEffect(() => {
    if (props.mode !== "web") {
      props.setPrintMode(true);
    } else {
      props.setPrintMode(false);
    }
  }, [props.mode]);

  useEffect(() => {
    if (props.firebaseReady && !props.membersLoaded) {
      props.loadMembers();
    }

    props.updateFilteredMembers(props.searchValue, props.teamId, props.status);
  }, [
    props.firebaseReady,
    props.membersLoaded,
    props.searchValue,
    props.teamId,
    props.status
  ]);

  const membercsvHeader = (
    <div className="members-header-wrapper">
      <img src="/icons/apple-icon-72x72.png" />
      <h3>Medlemmer</h3>

      <div className="header-bottom">
        <Search
          searchValue={props.searchValue}
          changed={e => {
            const statusId = props.status ? props.status : "any";
            props.history.push(
              "/memberscsv/" +
                props.teamId +
                "/" +
                statusId +
                "/" +
                e.target.value
            );
            props.updateFilteredMembers(
              e.target.value,
              props.teamId,
              props.status
            );
          }}
        />
        <TeamFilter
          page="/members/"
          searchValue={props.searchValue}
          teamId={props.teamId}
          changed={props.updateFilteredMembers}
        />
      </div>
    </div>
  );
  const memberHeader = (
    <HeaderWrapper status={props.status}>
      <div className="members-header-top">
        <img src="/icons/apple-icon-72x72.png" />
        <div className="header-title">
          <h3>{props.status == "ny" && "Nye "}Medlemmer</h3>
          <h3 style={{ color: "yellow" }}>
            {props.foundNewMembersCount > 0 && <><KickIcon />{props.foundNewMembersCount}</>}
          </h3>
        </div>
      </div>
      <div className="header-bottom">
        <Search
          searchValue={props.searchValue}
          changed={e => {
            // props.updateFilteredMembers(e.target.value)} />
            const statusId = props.status ? props.status : "any";
            props.history.push(
              "/members/" + props.teamId + "/" + statusId + "/" + e.target.value
            );
            props.updateFilteredMembers(
              e.target.value,
              props.teamId,
              props.status
            );
          }}
        />
        <TeamFilter
          page="/members/"
          searchValue={props.searchValue}
          teamId={props.teamId}
          status={props.status}
          changed={props.updateFilteredMembers}
        />
      </div>
    </HeaderWrapper>
  );

  let membersPage = null;


  if (props.mode == "web") {
    let membersList = [...props.filteredMembers];
    let memberRanks = [];
    membersList = props.filteredMembers.map(member => {
      memberRanks = props.ranks.filter(rank => {
        return rank.MemberId == member.ID;
      });

      return (
        <Member
          deleteMember={props.deleteMember}
          member={member}
          key={member.ID}
          memberRanks={memberRanks}
        />
      );
    });




    membersPage = (
      <div className="members-page">
        <Menu currentlyLoggedInUser={props.currentlyLoggedInUser} />
        {memberHeader}
        <div className="members-wrapper">
          <Link className="btn-new-member" to={`/edit/member/new`}>
            <NewIcon />
          </Link>
          {membersList}
        </div>
      </div>
    );
    
  } else if (props.mode == "membersDetailTable") {
    membersPage = (
      <MembersDetailTable
        // membersList={membersList}
        filteredMembers={props.filteredMembers}
        // memberRanks={memberRanks}
        teams={props.teams}
        ranks={props.ranks}
        teamId={props.teamId}
      />
    );
  } else if (props.mode == "membersKeikenTable") {
    membersPage = (
      <MembersKeikenTable
        // membersList={membersList}
        filteredMembers={props.filteredMembers}
        // memberRanks={memberRanks}
        teams={props.teams}
        ranks={props.ranks}
        teamId={props.teamId}
      />
    );
  } else if (props.mode == "csv") {
    membersPage = (
      <MemberCSV
        // membersList={membersList}
        filteredMembers={props.filteredMembers}
        // memberRanks={memberRanks}
        teams={props.teams}
        ranks={props.ranks}
        teamId={props.teamId}
      />
    );
  } else if (props.mode == "membersTestSheet") {
    membersPage = (
      <MemberTestSheet
        // membersList={membersList}
        filteredMembers={props.filteredMembers}
        // memberRanks={memberRanks}
        teams={props.teams}
        ranks={props.ranks}
        teamId={props.teamId}
      />
    );
  } else if (props.mode == "membersTestResultSheet") {
    membersPage = (
      <MemberTestResultSheet
        // membersList={membersList}
        filteredMembers={props.filteredMembers}
        // memberRanks={memberRanks}
        teams={props.teams}
        ranks={props.ranks}
        teamId={props.teamId}
      />
    );
  }

  return <>{membersPage}</>;
};

export default withRouter(Members);
